import React from 'react';
import { elementInfo } from '../data/assessmentData';
interface QuestionProps {
  question: {
    id: number;
    text: string;
    options: Array<{
      text: string;
      element: string;
    }>;
  };
  selectedElement: string | undefined;
  onSelect: (questionId: number, element: string) => void;
}
const Question = ({
  question,
  selectedElement,
  onSelect
}: QuestionProps) => {
  return <div className="bg-white rounded-xl p-6 mb-6 shadow-md hover:shadow-lg transition-shadow border border-gray-100" data-id="element-34">
      <div className="text-lg font-semibold text-gray-800 mb-5" data-id="element-35">
        {question.id}. {question.text}
      </div>
      <div className="space-y-3" data-id="element-36">
        {question.options.map((option, index) => <label key={index} className={`flex items-start p-4 border-2 rounded-lg cursor-pointer transition-all hover:border-indigo-500 hover:bg-indigo-50 hover:translate-x-1 ${selectedElement === option.element ? 'border-indigo-500 bg-indigo-50 shadow-md' : 'border-gray-200 bg-gray-50'}`} onClick={() => onSelect(question.id, option.element)} data-id="element-37">
            <input type="radio" name={`q${question.id}`} value={option.element} checked={selectedElement === option.element} onChange={() => {}} // Handled by onClick on label
        className="mt-1 mr-3 h-4 w-4 transform scale-110" data-id="element-38" />
            <div className="flex-1" data-id="element-39">
              <span className="text-gray-700" data-id="element-40">{option.text}</span>
            </div>
            <span className={`text-xs px-2 py-1 rounded-full font-semibold ml-2 ${option.element === 'wood' ? 'bg-green-100 text-green-800' : option.element === 'fire' ? 'bg-red-100 text-red-800' : option.element === 'earth' ? 'bg-yellow-100 text-yellow-800' : option.element === 'metal' ? 'bg-gray-200 text-gray-800' : 'bg-blue-100 text-blue-800'}`} data-id="element-41">
              {elementInfo[option.element].name}
            </span>
          </label>)}
      </div>
    </div>;
};
export default Question;